import React from 'react';
import { X } from 'lucide-react';

interface AddUserHeaderProps {
  onClose: () => void;
  title?: string;
}

export const GroupHeader: React.FC<AddUserHeaderProps> = ({ onClose, title = 'ADD Group' }) => {
  return (
    <div className="flex justify-between items-center border-b border-gray-200 px-8 py-4">
      <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
      <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition">
        <X size={20} />
      </button>
    </div>
  );
};
